/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the OrderStatsDTO interface.
 */
export function instanceOfOrderStatsDTO(value) {
    return true;
}
export function OrderStatsDTOFromJSON(json) {
    return OrderStatsDTOFromJSONTyped(json, false);
}
export function OrderStatsDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'flag': json['flag'] == null ? undefined : json['flag'],
        'unshippedCount': json['unshippedCount'] == null ? undefined : json['unshippedCount'],
        'unshippedTotalSales': json['unshippedTotalSales'] == null ? undefined : json['unshippedTotalSales'],
        'shippedCount': json['shippedCount'] == null ? undefined : json['shippedCount'],
        'shippedTotalSales': json['shippedTotalSales'] == null ? undefined : json['shippedTotalSales'],
        'deliveredCount': json['deliveredCount'] == null ? undefined : json['deliveredCount'],
        'deliveredTotalSales': json['deliveredTotalSales'] == null ? undefined : json['deliveredTotalSales'],
        'cancelledCount': json['cancelledCount'] == null ? undefined : json['cancelledCount'],
        'cancelledTotalSales': json['cancelledTotalSales'] == null ? undefined : json['cancelledTotalSales'],
        'shipByAtRiskCount': json['shipByAtRiskCount'] == null ? undefined : json['shipByAtRiskCount'],
        'deliverByAtRiskCount': json['deliverByAtRiskCount'] == null ? undefined : json['deliverByAtRiskCount'],
    };
}
export function OrderStatsDTOToJSON(json) {
    return OrderStatsDTOToJSONTyped(json, false);
}
export function OrderStatsDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'countryCode': value['countryCode'],
        'flag': value['flag'],
        'unshippedCount': value['unshippedCount'],
        'unshippedTotalSales': value['unshippedTotalSales'],
        'shippedCount': value['shippedCount'],
        'shippedTotalSales': value['shippedTotalSales'],
        'deliveredCount': value['deliveredCount'],
        'deliveredTotalSales': value['deliveredTotalSales'],
        'cancelledCount': value['cancelledCount'],
        'cancelledTotalSales': value['cancelledTotalSales'],
        'shipByAtRiskCount': value['shipByAtRiskCount'],
        'deliverByAtRiskCount': value['deliverByAtRiskCount'],
    };
}
